import Vue from 'vue'
import NotLogin from '../components/dialog/NotLogin'
/**
 * 自有组价
*/

Vue.component('notLogin', NotLogin)